import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedWarehouseMemberAccesses } from 'contracts/WarehouseMemberAccesses';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_WAREHOUSE_MEMBER_ACCESSES_',
  }
);

export interface ListWarehouseMemberAccessesState {
  data: ListedWarehouseMemberAccesses[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListWarehouseMemberAccessesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedWarehouseMemberAccesses[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListWarehouseMemberAccessesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListWarehouseMemberAccessesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: ListWarehouseMemberAccessesState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: ListWarehouseMemberAccessesState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListWarehouseMemberAccessesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listWarehouseMemberAccesses = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListWarehouseMemberAccessesTypes = Types;
export const ListWarehouseMemberAccessesActions = Creators;
